<sh-access-bar label='Search Copilot' slot='access'>
  <sh-tabs slot='tabs'>
    <sh-tab-item 
      *ngFor="let tab of tabs; let i = index" 
      [label]='tab.tabName' 
      [active]="tab.isActive"
      (click)="onTabClicked(i)">
    </sh-tab-item>
  </sh-tabs>
</sh-access-bar>
